import axios from 'axios'
import appconst from '../utiltools/appconst'

const authClient = axios.create({
  baseURL: appconst.remoteServiceBaseUrl,
  timeout: 30000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

const encodeForm = values =>
  Object.keys(values)
    .filter(key => values[key] !== undefined && values[key] !== null)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(values[key])}`)
    .join('&')

export const requestCaptcha = tenantId => {
  const config = {}
  if (tenantId) config.headers = { 'Abp.TenantId': tenantId.toString() }
  return authClient.get('/api/auth/captcha', config)
}

export const requestPasswordToken = (
  username,
  password,
  tenantId,
  captchaId,
  captchaCode
) => {
  const config = {}
  if (tenantId) config.headers = { 'Abp.TenantId': tenantId.toString() }

  return authClient.post(
    '/connect/token',
    encodeForm({
      grant_type: 'password',
      client_id: appconst.clientId,
      username,
      password,
      captcha_id: captchaId,
      captcha_code: captchaCode,
      scope: 'Ednet offline_access'
    }),
    config
  )
}

export const requestRefreshToken = refreshToken =>
  authClient.post(
    '/connect/token',
    encodeForm({
      grant_type: 'refresh_token',
      client_id: appconst.clientId,
      refresh_token: refreshToken
    })
  )

export const revokeRefreshToken = refreshToken =>
  authClient.post(
    '/connect/revocation',
    encodeForm({
      client_id: appconst.clientId,
      token: refreshToken,
      token_type_hint: 'refresh_token'
    })
  )

export default authClient



// WEBPACK FOOTER //
// ./src/auth/openIddictClient.js